import { object, string } from 'yup';
import { NO_SPECIAL_SYMBOLS_REGEX } from './noSpecialCharactersRegex';
import { FieldErrors } from 'react-hook-form';

export interface NameStepFields {
  first_name: string;
  last_name: string;
}

const fullNameInfoSchema = object().shape({
  first_name: string()
    .trim()
    .required('Please enter your first\u00A0name.')
    .min(2, 'Please enter two or more characters for your first\u00A0name.')
    .max(40, 'Please enter 40 characters or less for your first\u00A0name.')
    .matches(
      NO_SPECIAL_SYMBOLS_REGEX,
      'Please enter letters (a–z) for your first\u00A0name.'
    ),

  last_name: string()
    .trim()
    .required('Please enter your last\u00A0name.')
    .min(2, 'Please enter two or more characters for your last\u00A0name.')
    .max(80, 'Please enter 80 characters or less for your last\u00A0name.')
    .matches(
      NO_SPECIAL_SYMBOLS_REGEX,
      'Please enter letters (a–z) for your last\u00A0name.'
    )
});

function consolidateFirstAndLastNameErrors(
  errors: FieldErrors<NameStepFields>
): string | undefined {
  const firstError = errors.first_name;
  const lastError = errors.last_name;

  if (firstError?.type === 'required' && lastError?.type === 'required') {
    // When both required errors are present, show a single combined message
    return 'Please enter your first and last name.';
  }

  if (firstError) {
    return firstError.message as string;
  }

  if (lastError) {
    return lastError.message as string;
  }

  return undefined;
}

export { fullNameInfoSchema, consolidateFirstAndLastNameErrors };
